import { NoOp } from "./functions.utils";
import { toCamelCase } from "./string.utils";
export function makeActionConfig(label, action, options) {
    var _a;
    if (options === void 0) { options = {}; }
    options.name = (_a = options.name) !== null && _a !== void 0 ? _a : toCamelCase(label);
    options.label = label;
    options.action = action;
    return options;
}
export var makeCancelAction = function (label) {
    if (label === void 0) { label = 'Cancel'; }
    return makeActionConfig(label, NoOp, { buttonClass: 'subtle' });
};
